import { useEffect, useMemo } from 'react';
import { ANALYTICS_PAGE_ID } from '@config/logging';
import { Page } from '@config/page';
import { computePageViewData, sendPageView } from '@helpers/logging/analytics/page-view-event';
import { ROLE_TYPE } from '@types';
import { geometryGetType } from '@selectors/geometry';
import { useEventBus } from '@hooks/logging';
import { useNavigator } from '@hooks/routing';
import { useStorage } from '@hooks/storage';
import { useTypedSelector } from '@hooks/store';
import { FilledProfileRequired } from '@managers/access-control/filled-profile-required';
import { RoleAccessControl } from '@managers/access-control/role-access-control';
import { PreventSSR } from '@managers/seo/prevent-ssr';
import { TopMembersScene } from '@scenes/top-members';
import { LayoutWidget } from '@widgets/layout';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const Top100Page: Page = () => {
  const navigator = useNavigator();
  const eventBus = useEventBus();
  const storage = useStorage();
  const geometryType = useTypedSelector(geometryGetType);
  const disallowedRoleTypes = useMemo(() => [ROLE_TYPE.SPECIALIST], []);
  useEffect(() => {
    const _sendPageView = async () => {
      sendPageView(eventBus, {
        ...(await computePageViewData({
          navigator,
          storage,
          geometryType
        })),
        pageId: ANALYTICS_PAGE_ID.TOP100
      });
    };
    _sendPageView();
  }, [eventBus, geometryType, navigator, storage]);
  return _jsx(PreventSSR, {
    children: _jsx(RoleAccessControl, {
      disallowedRoleTypes: disallowedRoleTypes,
      children: _jsx(FilledProfileRequired, {
        children: _jsx(TopMembersScene, {})
      })
    })
  });
};
Top100Page.layout = LayoutWidget;
export default Top100Page;